export default __webpack_public_path__ + "static/background-header-71828b7a964d189986cb53a606ed6169.png";